import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
  padding: 20px 0px 5px 0px;
  display: flex;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;

export const ItemTitle = styled.span<{ isLink: boolean }>`
  font-size: 0.9rem;
  text-decoration: none;
  color: ${({ isLink, theme }) =>
    isLink ? `${theme.palette.primary}` : `${theme.palette.black}`};
  cursor: ${({ isLink }) => (isLink ? 'pointer' : 'default')}; ;
`;

export const Separator = styled.span`
  padding: 0px 10px;
  color: ${({ theme }) => theme.palette.black};
`;
